export enum TaOnboardingTasks {
  PROFILE_ONBOARDING_WIZARD = 'PROFILE_ONBOARDING_WIZARD',
}
